import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
const getBillingCycleDuration = cycle => {
  var _cycle$cycleDuration;
  if (((_cycle$cycleDuration = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration.unit) === PurchaseOffering.DurationUnit.YEAR) {
    return 'YEAR';
  }
  return 'SHORT_TERM';
};
export const getRevShareAmountByProductAndCycleQueryFn = async props => {
  var _revShareRatesByCycle;
  const {
    httpClient,
    request
  } = props;
  const apiClient = await import('../rev-share.api-client');
  const revShareRateResponse = await apiClient.RevShareApiClient.queries({
    httpClient
  }).getRevshareRate({
    productId: request.productId,
    siteGuid: request.siteGuid,
    productTypeId: request.productTypeId
  });
  const revShareRatesByCycle = revShareRateResponse[request.productId];
  const billingCycleDuration = getBillingCycleDuration(request.cycle);
  const revShareRate = (revShareRatesByCycle == null || (_revShareRatesByCycle = revShareRatesByCycle.find(r => r.billingCycleDuration === billingCycleDuration)) == null ? void 0 : _revShareRatesByCycle.rate) ?? 0;
  const amount = request.price * (revShareRate / 100);
  return {
    amount
  };
};
//# sourceMappingURL=get-revshare-amount-by-product-and-cycle.query.js.map